import React from "react";
import classnames from "classnames";

const iconLayouts = color => ({
  chat: (
    <svg
      width="30"
      height="27"
      viewBox="0 0 30 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.29182 26.1197C4.29182 24.225 4.29182 22.5656 4.29182 20.9606C4.16982 20.8687 4.12882 20.8162 4.07582 20.8041C1.00693 20.0972 0.00195912 18.9 0.00195912 15.9403C0.00195912 12.3075 -0.00404068 8.67469 0.00495902 5.04188C0.0109588 2.3175 1.7259 0.692815 4.6498 0.685315C11.5696 0.670315 18.4873 0.667502 25.4081 0.684377C28.285 0.691877 29.983 2.31844 29.991 5.01C30 8.29688 30.004 11.5837 29.993 14.8716C29.98 18.5878 27.75 20.7291 23.7732 20.7741C20.1753 20.8144 16.5784 20.8003 12.9795 20.7722C12.1986 20.7656 11.5776 20.9587 10.9586 21.4069C8.82266 22.9556 6.64874 24.4603 4.29182 26.1197ZM7.19672 20.7019C8.34168 19.9031 9.31565 19.1719 10.3506 18.5259C10.7536 18.2747 11.2926 18.0956 11.7716 18.0909C15.8294 18.0581 19.8873 18.0788 23.9452 18.0703C26.0181 18.0647 27.1331 17.0081 27.1341 15.0741C27.1381 11.7881 27.1351 8.50125 27.1331 5.21438C27.1321 3.78563 26.6781 3.34969 25.1761 3.34875C18.3523 3.34313 11.5266 3.34219 4.7008 3.34125C3.43184 3.34125 2.87086 3.82313 2.86686 4.995C2.85286 8.80031 2.85086 12.6047 2.86586 16.41C2.87086 17.6278 3.36285 18.0544 4.6768 18.0703C5.49078 18.0806 6.30675 18.0722 7.19772 18.0722C7.19672 18.9937 7.19672 19.7578 7.19672 20.7019Z"
        fill={color}
      />
      <path
        d="M14.2887 8.71027C11.9548 8.71027 9.61985 8.71496 7.28593 8.70746C6.61995 8.70558 5.99797 8.48621 5.86697 7.83933C5.78098 7.41371 5.87497 6.84465 6.13297 6.5034C6.34896 6.21933 6.91994 6.04402 7.33593 6.04027C11.9128 6.00652 16.4876 6.01027 21.0645 6.01777C22.2044 6.01871 22.8404 6.51746 22.8554 7.34715C22.8724 8.20027 22.2034 8.70652 21.0135 8.71027C18.7715 8.71871 16.5296 8.71308 14.2857 8.71308C14.2887 8.71215 14.2887 8.71121 14.2887 8.71027Z"
        fill={color}
      />
      <path
        d="M12.9253 14.0716C11.1134 14.0725 9.30244 14.0772 7.4905 14.0706C6.38854 14.0659 5.72656 13.5522 5.72656 12.7234C5.72556 11.89 6.35954 11.3978 7.4995 11.3941C11.0614 11.3856 14.6213 11.3837 18.1831 11.3922C19.4171 11.395 19.9981 11.8628 19.9701 12.7722C19.9451 13.6178 19.3331 14.0669 18.1761 14.0697C16.4252 14.0744 14.6753 14.0716 12.9253 14.0716Z"
        fill={color}
      />
    </svg>
  ),
  notes: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M17.975 4.37502C17.975 4.11305 17.7611 3.9 17.4999 3.9C17.2388 3.9 17.0249 4.11305 17.0249 4.37502C17.0249 4.63695 17.2388 4.84998 17.4999 4.85004L17.975 4.37502ZM17.975 4.37502C17.975 4.63698 17.7611 4.85003 17.5 4.85004L17.975 4.37502ZM25.475 27.975H25.4749V28.125C25.4749 28.387 25.261 28.6 24.9999 28.6H4.99991C4.73879 28.6 4.52489 28.387 4.52489 28.125V1.875C4.52489 1.61303 4.73879 1.39998 4.99991 1.39998H6.72491V2.51216C5.99396 2.81665 5.47493 3.53253 5.47493 4.37502C5.47493 5.49163 6.38332 6.40002 7.49993 6.40002C8.61654 6.40002 9.52493 5.49163 9.52493 4.37502C9.52493 3.53252 9.00589 2.8167 8.27495 2.51222V1.39998H11.7249V2.51216C10.9939 2.81664 10.475 3.53247 10.475 4.37496C10.475 5.49157 11.3834 6.39996 12.5 6.39996C13.6166 6.39996 14.525 5.49157 14.525 4.37496C14.525 3.53246 14.0059 2.81664 13.275 2.51216V1.39998H16.725V2.51216C15.994 2.81664 15.475 3.53247 15.475 4.37496C15.475 5.49157 16.3834 6.39996 17.5 6.39996C18.6166 6.39996 19.525 5.49157 19.525 4.37496C19.525 3.53246 19.006 2.81664 18.275 2.51216V1.39998H21.725V2.51216C20.994 2.81664 20.4749 3.53252 20.4749 4.37502C20.4749 5.49163 21.3833 6.40002 22.4999 6.40002C23.6165 6.40002 24.5249 5.49163 24.5249 4.37502C24.5249 3.53252 24.0059 2.8167 23.2749 2.51222V1.39998H24.9999C25.2611 1.39998 25.475 1.61304 25.475 1.875V27.975ZM24.9999 -0.15H4.99991C3.8833 -0.15 2.97491 0.758388 2.97491 1.875V28.125C2.97491 29.2416 3.8833 30.15 4.99991 30.15H24.9999C26.1165 30.15 27.0249 29.2416 27.0249 28.125V1.875C27.025 0.758385 26.1165 -0.15 24.9999 -0.15ZM22.4999 3.9C22.761 3.9 22.9749 4.11305 22.9749 4.37502C22.9749 4.63698 22.761 4.85004 22.4999 4.85004C22.2388 4.85004 22.0249 4.63698 22.0249 4.37502C22.0249 4.11305 22.2388 3.9 22.4999 3.9ZM12.4999 3.9C12.761 3.9 12.9749 4.11305 12.9749 4.37502C12.9749 4.63698 12.761 4.85004 12.4999 4.85004C12.2388 4.85004 12.0249 4.63698 12.0249 4.37502C12.0249 4.11306 12.2388 3.9 12.4999 3.9ZM7.49993 3.9C7.76105 3.9 7.97495 4.11305 7.97495 4.37502C7.97495 4.63698 7.76105 4.85004 7.49993 4.85004C7.23881 4.85004 7.02491 4.63698 7.02491 4.37502C7.02491 4.11305 7.23881 3.9 7.49993 3.9Z"
          fill={color}
          stroke={color}
          stroke-width="0.3"
        />
        <path
          d="M22.4999 12.35H7.49993C7.07209 12.35 6.72491 12.6972 6.72491 13.125C6.72491 13.5529 7.07209 13.9 7.49993 13.9H22.4999C22.9278 13.9 23.2749 13.5529 23.2749 13.125C23.2749 12.6972 22.9278 12.35 22.4999 12.35Z"
          fill={color}
          stroke={color}
          stroke-width="0.3"
        />
        <path
          d="M22.4999 17.35H7.49993C7.07208 17.35 6.72491 17.6972 6.72491 18.125C6.72491 18.5529 7.0721 18.9 7.49993 18.9H22.4999C22.9278 18.9 23.2749 18.5528 23.2749 18.125C23.2749 17.6971 22.9278 17.35 22.4999 17.35Z"
          fill={color}
          stroke={color}
          stroke-width="0.3"
        />
        <path
          d="M18.7499 22.35H7.49993C7.07209 22.35 6.72491 22.6972 6.72491 23.125C6.72491 23.5529 7.07208 23.9 7.49993 23.9H18.7499C19.1778 23.9 19.5249 23.5529 19.5249 23.125C19.5249 22.6972 19.1778 22.35 18.7499 22.35Z"
          fill={color}
          stroke={color}
          stroke-width="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  share: (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.8301 7.63712L20.2013 1.04127C19.9148 0.756103 19.4851 0.671508 19.1126 0.826753C18.7395 0.981639 18.4967 1.34576 18.4967 1.74951V4.74361C15.2104 4.96079 13.5695 6.32328 13.273 6.59476C9.14923 10.0269 9.60528 14.707 9.74386 15.6381C9.74586 15.6514 9.74786 15.665 9.75016 15.6784L9.88341 16.4445C9.95504 16.8563 10.2745 17.1798 10.6849 17.256C10.7462 17.2674 10.8075 17.273 10.8682 17.273C11.2149 17.273 11.5424 17.0924 11.7249 16.7876L12.1243 16.1221C14.3076 12.491 17.0056 11.9064 18.4966 11.9014V15.0078C18.4966 15.4125 18.7408 15.777 19.1153 15.9315C19.4897 16.0857 19.9197 15.9991 20.2049 15.7126L26.8338 9.05022C27.2229 8.65913 27.2212 8.02621 26.8301 7.63712ZM20.4958 12.5863V10.977C20.4958 10.4863 20.14 10.0682 19.6556 9.9903C18.5024 9.80476 14.8726 9.58122 11.7379 13.2396C11.9402 11.7465 12.6091 9.7398 14.5705 8.11578C14.5945 8.09578 14.6028 8.08912 14.6248 8.06712C14.6395 8.05348 16.1299 6.71298 19.3961 6.71298H19.496C20.048 6.71298 20.4954 6.2656 20.4954 5.71363V4.15365L24.7121 8.34869L20.4958 12.5863Z"
        fill={color}
      />
      <path
        d="M23.1943 18.1728C22.6423 18.1728 22.1949 18.6202 22.1949 19.1722V22.0037H2.87375V7.34636H8.86996C9.42193 7.34636 9.86931 6.89898 9.86931 6.34701C9.86931 5.79504 9.42193 5.34766 8.86996 5.34766H1.87435C1.32238 5.3476 0.875 5.79498 0.875 6.34696V23.0031C0.875 23.5551 1.32238 24.0025 1.87435 24.0025H23.1943C23.7462 24.0025 24.1936 23.5551 24.1936 23.0031V19.1722C24.1936 18.6202 23.7462 18.1728 23.1943 18.1728Z"
        fill={color}
      />
    </svg>
  ),

  audioOn: (
    <svg
      width="18"
      height="25"
      viewBox="0 0 18 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.625 11.75C15.625 15.5 12.45 18.125 9 18.125C5.55 18.125 2.375 15.5 2.375 11.75H0.25C0.25 16.0125 3.65 19.5375 7.75 20.15V24.25H10.25V20.15C14.35 19.5375 17.75 16.0125 17.75 11.75H15.625ZM7.5 4.125C7.5 3.3 8.175 2.625 9 2.625C9.825 2.625 10.5 3.3 10.5 4.125L10.4875 11.875C10.4875 12.7 9.825 13.375 9 13.375C8.175 13.375 7.5 12.7 7.5 11.875V4.125ZM9 15.5C9.99456 15.5 10.9484 15.1049 11.6517 14.4017C12.3549 13.6984 12.75 12.7446 12.75 11.75V4.25C12.75 3.25544 12.3549 2.30161 11.6517 1.59835C10.9484 0.895088 9.99456 0.5 9 0.5C8.00544 0.5 7.05161 0.895088 6.34835 1.59835C5.64509 2.30161 5.25 3.25544 5.25 4.25V11.75C5.25 12.7446 5.64509 13.6984 6.34835 14.4017C7.05161 15.1049 8.00544 15.5 9 15.5Z"
        fill={color}
      />
    </svg>
  ),
  audioOff: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 11.75C20.75 13.2375 20.325 14.625 19.625 15.85L18.0875 14.3125C18.425 13.5375 18.625 12.675 18.625 11.75H20.75ZM15.75 11.95L8.25 4.475V4.25C8.25 3.25544 8.64509 2.30161 9.34835 1.59835C10.0516 0.895088 11.0054 0.5 12 0.5C12.9946 0.5 13.9484 0.895088 14.6517 1.59835C15.3549 2.30161 15.75 3.25544 15.75 4.25V11.95ZM2.3375 1.75L23.25 22.6625L21.6625 24.25L16.425 19.0125C15.4625 19.5875 14.3875 19.975 13.25 20.15V24.25H10.75V20.15C6.65 19.5375 3.25 16.0125 3.25 11.75H5.375C5.375 15.5 8.55 18.125 12 18.125C13.0125 18.125 14 17.8875 14.8875 17.475L12.8125 15.4L12 15.5C11.0054 15.5 10.0516 15.1049 9.34835 14.4017C8.64509 13.6984 8.25 12.7446 8.25 11.75V10.85L0.75 3.3375L2.3375 1.75Z"
        fill={color}
      />
    </svg>
  ),
  videoOn: (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 3V13H3.25V3H15.75ZM17 0.5H2C1.66848 0.5 1.35054 0.631696 1.11612 0.866117C0.881696 1.10054 0.75 1.41848 0.75 1.75V14.25C0.75 14.5815 0.881696 14.8995 1.11612 15.1339C1.35054 15.3683 1.66848 15.5 2 15.5H17C17.3315 15.5 17.6495 15.3683 17.8839 15.1339C18.1183 14.8995 18.25 14.5815 18.25 14.25V9.875L23.25 14.875V1.125L18.25 6.125V1.75C18.25 1.41848 18.1183 1.10054 17.8839 0.866117C17.6495 0.631696 17.3315 0.5 17 0.5Z"
        fill={color}
      />
    </svg>
  ),
  videoOff: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0875 0.5L0.5 2.0875L3.9125 5.5H3C2.66848 5.5 2.35054 5.6317 2.11612 5.86612C1.8817 6.10054 1.75 6.41848 1.75 6.75V19.25C1.75 19.5815 1.8817 19.8995 2.11612 20.1339C2.35054 20.3683 2.66848 20.5 3 20.5H18C18.25 20.5 18.4875 20.4 18.675 20.275L22.6625 24.25L24.25 22.6625L2.0875 0.5ZM24.25 6.125L19.25 11.125V6.75C19.25 6.41848 19.1183 6.10054 18.8839 5.86612C18.6495 5.6317 18.3315 5.5 18 5.5H10.275L24.25 19.475V6.125Z"
        fill={color}
      />
    </svg>
  ),
  addParticipants: (
    <svg
      width="28"
      height="20"
      viewBox="0 0 28 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.75 0C16.4239 0 15.1521 0.526784 14.2145 1.46447C13.2768 2.40215 12.75 3.67392 12.75 5C12.75 6.32608 13.2768 7.59785 14.2145 8.53553C15.1521 9.47322 16.4239 10 17.75 10C19.0761 10 20.3479 9.47322 21.2855 8.53553C22.2232 7.59785 22.75 6.32608 22.75 5C22.75 3.67392 22.2232 2.40215 21.2855 1.46447C20.3479 0.526784 19.0761 0 17.75 0ZM17.75 2.375C18.0947 2.375 18.4361 2.4429 18.7545 2.57482C19.073 2.70673 19.3624 2.90009 19.6062 3.14384C19.8499 3.3876 20.0433 3.67698 20.1752 3.99546C20.3071 4.31394 20.375 4.65528 20.375 5C20.375 5.34472 20.3071 5.68606 20.1752 6.00454C20.0433 6.32302 19.8499 6.6124 19.6062 6.85616C19.3624 7.09991 19.073 7.29327 18.7545 7.42518C18.4361 7.5571 18.0947 7.625 17.75 7.625C17.4053 7.625 17.0639 7.5571 16.7455 7.42518C16.427 7.29327 16.1376 7.09991 15.8938 6.85616C15.6501 6.6124 15.4567 6.32302 15.3248 6.00454C15.1929 5.68606 15.125 5.34472 15.125 5C15.125 4.30381 15.4016 3.63613 15.8938 3.14384C16.3861 2.65156 17.0538 2.375 17.75 2.375ZM4 3.75V7.5H0.25V10H4V13.75H6.5V10H10.25V7.5H6.5V3.75H4ZM17.75 11.25C14.4125 11.25 7.75 12.9125 7.75 16.25V20H27.75V16.25C27.75 12.9125 21.0875 11.25 17.75 11.25ZM17.75 13.625C21.4625 13.625 25.375 15.45 25.375 16.25V17.625H10.125V16.25C10.125 15.45 14 13.625 17.75 13.625Z"
        fill={color}
      />
    </svg>
  ),
  callEnd: (
    <svg
      width="30"
      height="12"
      viewBox="0 0 30 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.6375 6.58745C25.6881 2.83469 20.4481 0.742187 15 0.742188C9.55195 0.742187 4.31199 2.83469 0.362521 6.58745C0.246669 6.70425 0.155013 6.84277 0.0928069 6.99506C0.0306011 7.14736 -0.000930223 7.31044 2.08929e-05 7.47495C0.00140167 7.80287 0.131591 8.11712 0.362521 8.34995L3.46252 11.4499C3.58228 11.5688 3.72486 11.6622 3.88169 11.7245C4.03851 11.7868 4.20633 11.8167 4.37502 11.8124C4.69252 11.808 4.99643 11.6828 5.22502 11.4624C6.21867 10.5386 7.33811 9.76 8.55002 9.14995C8.7604 9.04687 8.93758 8.88674 9.06134 8.68782C9.18511 8.48891 9.25049 8.25922 9.25002 8.02495V4.14995C11.1077 3.55069 13.0481 3.24698 15 3.24995C16.9491 3.24363 18.8865 3.55176 20.7375 4.16244V8.03745C20.7371 8.27172 20.8024 8.50141 20.9262 8.70032C21.05 8.89924 21.2271 9.05936 21.4375 9.16245C22.6559 9.76807 23.78 10.547 24.775 11.4749C25.0036 11.6953 25.3075 11.8205 25.625 11.8249C25.7937 11.8292 25.9615 11.7993 26.1184 11.737C26.2752 11.6747 26.4178 11.5813 26.5375 11.4624L29.6375 8.36245C29.7547 8.24624 29.8477 8.10799 29.9111 7.95567C29.9746 7.80334 30.0073 7.63996 30.0073 7.47495C30.0073 7.30993 29.9746 7.14655 29.9111 6.99423C29.8477 6.8419 29.7547 6.70365 29.6375 6.58745ZM6.75002 7.27495C5.92795 7.74272 5.1461 8.27788 4.41252 8.87495L3.07502 7.52495C4.20541 6.58867 5.43828 5.78353 6.75002 5.12495V7.27495ZM25.625 8.87495C24.8788 8.28079 24.0844 7.74979 23.25 7.28745V5.16245C24.5723 5.79929 25.8108 6.59699 26.9375 7.53745L25.625 8.87495Z"
        fill={color}
      />
    </svg>
  ),
  dots: (
    <svg
      width="22"
      height="6"
      viewBox="0 0 22 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.8125C0 4.36875 1.25625 5.625 2.8125 5.625C4.36875 5.625 5.625 4.36875 5.625 2.8125C5.625 1.25625 4.36875 0 2.8125 0C1.25625 0 0 1.25625 0 2.8125Z"
        fill={color}
      />
      <path
        d="M16 2.8125C16 4.36875 17.2563 5.625 18.8125 5.625C20.3688 5.625 21.625 4.36875 21.625 2.8125C21.625 1.25625 20.3688 0 18.8125 0C17.2563 0 16 1.25625 16 2.8125Z"
        fill={color}
      />
      <path
        d="M8 2.8125C8 4.36875 9.25625 5.625 10.8125 5.625C12.3688 5.625 13.625 4.36875 13.625 2.8125C13.625 1.25625 12.3688 0 10.8125 0C9.25625 0 8 1.25625 8 2.8125Z"
        fill={color}
      />
    </svg>
  ),
  screenshot: (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.949 13.6447C20.949 9.61676 17.6725 6.34018 13.6445 6.34018C9.61651 6.34018 6.33993 9.61681 6.33993 13.6447C6.33993 17.6727 9.61651 20.9493 13.6445 20.9493C17.6725 20.9493 20.949 17.6727 20.949 13.6447ZM13.6445 18.8493C10.7749 18.8493 8.43993 16.5144 8.43993 13.6448C8.43993 10.7752 10.7749 8.44023 13.6445 8.44023C16.5141 8.44023 18.849 10.7752 18.849 13.6447C18.849 16.5143 16.5141 18.8493 13.6445 18.8493ZM10.4945 1.64473C10.4945 1.06486 10.0244 0.594727 9.44448 0.594727H4.26263C2.23976 0.594727 0.594482 2.24001 0.594482 4.26288V9.44473C0.594482 10.0246 1.06461 10.4947 1.64448 10.4947C2.22435 10.4947 2.69448 10.0246 2.69448 9.44473V4.26288C2.69448 3.39845 3.3982 2.69473 4.26263 2.69473H9.44448C10.0244 2.69473 10.4945 2.2246 10.4945 1.64473ZM26.6945 23.0266V17.8447C26.6945 17.2648 26.2243 16.7947 25.6445 16.7947C25.0646 16.7947 24.5945 17.2648 24.5945 17.8447V23.0266C24.5945 23.8911 23.8908 24.5947 23.0263 24.5947H17.8445C17.2646 24.5947 16.7945 25.0648 16.7945 25.6447C16.7945 26.2247 17.2646 26.6947 17.8445 26.6947H23.0263C25.0492 26.6947 26.6945 25.0494 26.6945 23.0266ZM1.64448 16.7947C1.06462 16.7947 0.594482 17.2648 0.594482 17.8447V23.0266C0.594482 25.0494 2.23976 26.6947 4.26263 26.6947H9.44448C10.0243 26.6947 10.4945 26.2247 10.4945 25.6447C10.4945 25.0648 10.0243 24.5947 9.44448 24.5947H4.26263C3.3982 24.5947 2.69448 23.8911 2.69448 23.0266V17.8447C2.69448 17.2648 2.22434 16.7947 1.64448 16.7947ZM26.6945 9.44473V4.26288C26.6945 2.24 25.0492 0.594727 23.0263 0.594727H17.8445C17.2646 0.594727 16.7945 1.06486 16.7945 1.64473C16.7945 2.2246 17.2646 2.69473 17.8445 2.69473H23.0263C23.8908 2.69473 24.5945 3.39844 24.5945 4.26288V9.44473C24.5945 10.0246 25.0646 10.4947 25.6445 10.4947C26.2244 10.4947 26.6945 10.0246 26.6945 9.44473Z"
        fill="#333333"
        stroke="#333333"
        stroke-width="0.5"
      />
    </svg>
  ),
  prescreptions: (
    <svg
      width="26"
      height="32"
      viewBox="0 0 26 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9129 5.89962L19.2879 0.274625C19.1121 0.09875 18.8737 0 18.625 0H1.75C1.23225 0 0.8125 0.41975 0.8125 0.9375V31.0625C0.8125 31.5802 1.23225 32 1.75 32H24.25C24.7677 32 25.1875 31.5802 25.1875 31.0625V6.5625C25.1875 6.31381 25.0887 6.07537 24.9129 5.89962ZM19.5625 3.20081L21.9867 5.625H19.5625V3.20081ZM2.6875 30.125V1.875H17.6875V6.5625C17.6875 7.08025 18.1073 7.5 18.625 7.5H23.3125V30.125H2.6875Z"
        fill="#333333"
      />
      <path
        d="M12.7254 23.2121C12.3593 22.8461 11.7657 22.8461 11.3996 23.2121L10.4062 24.2054L8.76775 22.5669C9.615 22.0818 10.1875 21.1693 10.1875 20.125C10.1875 18.5742 8.92581 17.3125 7.375 17.3125H5.5C4.98225 17.3125 4.5625 17.7323 4.5625 18.25V25.3124C4.5625 25.8302 4.98225 26.2499 5.5 26.2499C6.01775 26.2499 6.4375 25.8302 6.4375 25.3124V22.9375H6.48669L9.08044 25.5313L8.08506 26.5266C7.71894 26.8927 7.71894 27.4863 8.08506 27.8524C8.45125 28.2186 9.04475 28.2186 9.41088 27.8524L10.4062 26.8571L11.3951 27.8459C11.7613 28.2121 12.3548 28.2121 12.7209 27.8459C13.0871 27.4799 13.0871 26.8863 12.7209 26.5201L11.7321 25.5313L12.7254 24.5379C13.0916 24.1718 13.0916 23.5782 12.7254 23.2121ZM6.4375 19.1875H7.375C7.89194 19.1875 8.3125 19.6081 8.3125 20.125C8.3125 20.6419 7.89194 21.0625 7.375 21.0625H6.4375V19.1875Z"
        fill="#333333"
      />
      <path
        d="M20.5 9.375H5.5C4.98225 9.375 4.5625 9.79475 4.5625 10.3125C4.5625 10.8303 4.98225 11.25 5.5 11.25H20.5C21.0177 11.25 21.4375 10.8303 21.4375 10.3125C21.4375 9.79475 21.0177 9.375 20.5 9.375Z"
        fill="#333333"
      />
      <path
        d="M20.5 13.125H5.5C4.98225 13.125 4.5625 13.5447 4.5625 14.0625C4.5625 14.5803 4.98225 15 5.5 15H20.5C21.0177 15 21.4375 14.5803 21.4375 14.0625C21.4375 13.5447 21.0177 13.125 20.5 13.125Z"
        fill="#333333"
      />
      <path
        d="M5.5 7.5H14.875C15.3927 7.5 15.8125 7.08025 15.8125 6.5625C15.8125 6.04475 15.3927 5.625 14.875 5.625H5.5C4.98225 5.625 4.5625 6.04475 4.5625 6.5625C4.5625 7.08025 4.98225 7.5 5.5 7.5Z"
        fill="#333333"
      />
      <path
        d="M20.5 16.875H14.875C14.3572 16.875 13.9375 17.2947 13.9375 17.8125C13.9375 18.3303 14.3572 18.75 14.875 18.75H20.5C21.0177 18.75 21.4375 18.3303 21.4375 17.8125C21.4375 17.2947 21.0177 16.875 20.5 16.875Z"
        fill="#333333"
      />
      <path
        d="M20.5 20.625H14.875C14.3572 20.625 13.9375 21.0447 13.9375 21.5625C13.9375 22.0803 14.3572 22.5 14.875 22.5H20.5C21.0177 22.5 21.4375 22.0803 21.4375 21.5625C21.4375 21.0447 21.0177 20.625 20.5 20.625Z"
        fill="#333333"
      />
    </svg>
  ),
  showVitals: (
    <svg
      width="22"
      height="32"
      viewBox="0 0 22 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.22038 20.7031C2.85857 20.7031 1.99151 18.4372 1.45482 16.2206C1.38713 15.9412 1.45145 15.6463 1.6292 15.4203C1.80694 15.1944 2.07851 15.0625 2.36601 15.0625H8.07475C8.36225 15.0625 8.63381 15.1944 8.81156 15.4203C8.98931 15.6463 9.05363 15.9412 8.98594 16.2206C8.44925 18.4372 7.58219 20.7031 5.22038 20.7031ZM3.60494 16.9375C4.23838 18.8282 4.86125 18.8281 5.22044 18.8281C5.57963 18.8281 6.2025 18.8282 6.83594 16.9375H3.60494Z"
        fill="black"
      />
      <path
        d="M8.75649 13.1719H1.68399C1.21774 13.1719 0.822304 12.8292 0.755991 12.3676C0.674366 11.7992 0.591429 11.1777 0.502491 10.4677C-0.0282588 6.22381 0.480804 3.19056 2.01549 1.45206C2.85405 0.502125 3.96224 0 5.22024 0C6.47824 0 7.58643 0.502125 8.42499 1.45206C9.95968 3.19056 10.4687 6.22387 9.93799 10.4676V10.4677C9.8493 11.176 9.76637 11.7975 9.68449 12.3676C9.61824 12.8292 9.2228 13.1719 8.75649 13.1719ZM2.50043 11.2969H7.94005C7.98468 10.9645 8.03024 10.6123 8.07749 10.2347C8.52555 6.652 8.14974 3.9735 7.0193 2.69287C6.54024 2.15019 5.93493 1.875 5.22024 1.875C4.50555 1.875 3.90024 2.15019 3.42118 2.69287C2.29074 3.9735 1.91493 6.652 2.36299 10.2349C2.41037 10.6128 2.45593 10.965 2.50043 11.2969Z"
        fill="black"
      />
      <path
        d="M16.78 32C14.4181 32 13.5511 29.7341 13.0144 27.5175C12.9467 27.2381 13.011 26.9431 13.1888 26.7172C13.3665 26.4913 13.6381 26.3594 13.9256 26.3594H19.6343C19.9218 26.3594 20.1934 26.4913 20.3712 26.7172C20.5489 26.9431 20.6132 27.2381 20.5455 27.5175C20.0089 29.7341 19.1418 32 16.78 32ZM15.1645 28.2344C15.798 30.1251 16.4208 30.125 16.78 30.125C17.1392 30.125 17.7621 30.1251 18.3955 28.2344H15.1645Z"
        fill="black"
      />
      <path
        d="M20.3163 24.4688H13.2438C12.7776 24.4688 12.3821 24.1261 12.3158 23.6645C12.2339 23.0943 12.151 22.4729 12.0623 21.7646C11.5316 17.5208 12.0406 14.4874 13.5753 12.7489C14.4139 11.799 15.522 11.2969 16.7801 11.2969C18.0381 11.2969 19.1462 11.799 19.9848 12.7489C21.5195 14.4874 22.0286 17.5207 21.4978 21.7645V21.7647C21.4089 22.4747 21.3259 23.0961 21.2443 23.6646C21.178 24.1261 20.7826 24.4688 20.3163 24.4688ZM14.0602 22.5938H19.4998C19.5443 22.2618 19.5899 21.9096 19.6372 21.5316C20.0853 17.9489 19.7095 15.2704 18.5791 13.9898C18.0999 13.4471 17.4947 13.1719 16.78 13.1719C16.0653 13.1719 15.46 13.4471 14.9809 13.9898C13.8505 15.2704 13.4747 17.9489 13.9227 21.5318C13.97 21.9093 14.0156 22.2614 14.0602 22.5938Z"
        fill="black"
      />
    </svg>
  ),
  subscriberAudioOn: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      fill="white"
      class="bi bi-volume-down"
      viewBox="0 0 16 16"
    >
      <path d="M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12V4zM6.312 6.39 8 5.04v5.92L6.312 9.61A.5.5 0 0 0 6 9.5H4v-3h2a.5.5 0 0 0 .312-.11zM12.025 8a4.486 4.486 0 0 1-1.318 3.182L10 10.475A3.489 3.489 0 0 0 11.025 8 3.49 3.49 0 0 0 10 5.525l.707-.707A4.486 4.486 0 0 1 12.025 8z" />
    </svg>
  ),
  subscriberAudioOff: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      fill="white"
      class="bi bi-volume-mute"
      viewBox="0 0 16 16"
    >
      <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM6 5.04 4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96V5.04zm7.854.606a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z" />
    </svg>
  ),
  subscriberVideoOn: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="white"
      class="bi bi-camera-video-off"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l.714 1H9.5a1 1 0 0 1 1 1v6a1 1 0 0 1-.144.518l.605.847zM1.428 4.18A.999.999 0 0 0 1 5v6a1 1 0 0 0 1 1h5.014l.714 1H2a2 2 0 0 1-2-2V5c0-.675.334-1.272.847-1.634l.58.814zM15 11.73l-3.5-1.555v-4.35L15 4.269v7.462zm-4.407 3.56-10-14 .814-.58 10 14-.814.58z"
      />
    </svg>
  ),
  subscriberVideoOff: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="white"
      class="bi bi-camera-video"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"
      />
    </svg>
  ),
  micOff: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="white"
      class="bi bi-mic-mute"
      viewBox="0 0 16 16"
    >
      <path d="M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879l-1-1V3a2 2 0 0 0-3.997-.118l-.845-.845A3.001 3.001 0 0 1 11 3z" />
      <path d="m9.486 10.607-.748-.748A2 2 0 0 1 6 8v-.878l-1-1V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z" />
    </svg>
  ),
  permissionBlocked: (
    <svg
      className="mt-2"
      width={16}
      height={14}
      viewBox="0 0 16 14"
      id="disabled-camera"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.62 6.096c0-.42.34-.762.761-.762h6.857c.42 0 .762.341.762.762v6.857c0 .42-.341.762-.762.762H8.38a.762.762 0 0 1-.762-.762V6.096z"
        fill="#D9453D"
      ></path>
      <path
        clip-rule="evenodd"
        d="M10.666.762v2.666L13.714.381v4.19H8.38c-.842 0-1.524.682-1.524 1.524v3.048H.762A.764.764 0 0 1 0 8.38V.76C0 .344.343 0 .762 0h9.142c.42 0 .762.343.762.762z"
      ></path>
      <path
        d="M14.476 7.395l-.537-.538-2.13 2.13-2.13-2.13-.536.538 2.129 2.129-2.13 2.13.538.537 2.13-2.13 2.129 2.13.537-.538-2.13-2.129 2.13-2.13z"
        fill="#fff"
      ></path>
    </svg>
  ),
  videoBlocked: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 24 24"
      fill={"#b30000"}
      id="call-video-off"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.047 22.567a.79.79 0 0 1-.29-1.08l11.48-19.882a.79.79 0 0 1 1.368.79L6.126 22.277a.79.79 0 0 1-1.08.29z"
      ></path>
      <path d="M1 15.29c0 1.828 1.495 3.31 3.338 3.31h.252l8.09-13.995H4.338C2.495 4.606 1 6.09 1 7.918v7.372zm22 .752V7.157a.893.893 0 0 0-1.345-.765l-3.73 2.134v-.608a3.28 3.28 0 0 0-.61-1.907L10.047 18.6h4.536c1.843 0 3.338-1.482 3.338-3.311v-.608l3.73 2.135c.6.341 1.349-.088 1.349-.775z"></path>
    </svg>
  ),
  refresh: (
    <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7006 7.58333C7.44168 9.11788 6.10647 10.2917 4.49935 10.2917C2.70752 10.2917 1.24935 8.8335 1.24935 7.04167C1.24935 5.24983 2.70752 3.79167 4.49935 3.79167H5.67585L4.54593 4.92158L5.31185 5.6875L7.74935 3.25L5.31185 0.8125L4.54593 1.57842L5.67585 2.70833H4.49935C3.35008 2.70833 2.24788 3.16488 1.43522 3.97754C0.622562 4.79019 0.166016 5.8924 0.166016 7.04167C0.166016 8.19094 0.622562 9.29314 1.43522 10.1058C2.24788 10.9185 3.35008 11.375 4.49935 11.375C6.70935 11.375 8.52826 9.72021 8.79477 7.58333H7.7006Z"
        fill="#BDBDBD"
      />
    </svg>
  ),
  profile: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="32"
      fill="none"
      class="bi bi-person"
      viewBox="0 0 16 16"
    >
      <path
        d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
        fill="#333333"
        stroke="#333333"
        stroke-width="0.5"
      />
    </svg>
  ),
});

const StartCallIcon = ({ onClick, className, type, active, initial }) => {
  const icon = iconLayouts(active ? "#333333" : "white")[type];
  return (
    <span
      className={classnames(!initial && "mr-2", className)}
      onClick={onClick}
    >
      {icon}
    </span>
  );
};

export default StartCallIcon;
